import React from "react";
import { Link } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Btn } from "@/components/common";
import { Camera, PaperPlaneTilt, CheckCircle } from "@phosphor-icons/react";

export function StudentWelcomeModal() {
  const qc = useQueryClient();
  const { data: prefs } = useQuery({ queryKey: ["user-prefs"], queryFn: async () => (await api.get("/user-prefs")).data });

  if (!prefs || prefs.student_welcome_shown) return null;

  const dismiss = async () => {
    await api.put("/user-prefs", { student_welcome_shown: true });
    qc.invalidateQueries({ queryKey: ["user-prefs"] });
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) dismiss(); }}>
      <DialogContent className="max-w-md" data-testid="student-welcome-modal">
        <DialogHeader>
          <DialogTitle>Welcome! Here's how it works</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm text-[#374151]">
          <div className="flex items-start gap-3">
            <Camera size={24} weight="bold" className="shrink-0 text-[#034AA2]" />
            <div><strong>1. Snap or upload</strong> — Take a photo of your receipt or upload a digital one from My Receipts.</div>
          </div>
          <div className="flex items-start gap-3">
            <PaperPlaneTilt size={24} weight="bold" className="shrink-0 text-[#D97706]" />
            <div><strong>2. Submit it</strong> — Fill in the details (store, amount, date) and hit Submit. It goes to the account owner for review.</div>
          </div>
          <div className="flex items-start gap-3">
            <CheckCircle size={24} weight="bold" className="shrink-0 text-[#077A39]" />
            <div><strong>3. Wait for approval</strong> — Nothing counts until the account owner approves it. If they return it, just fix it and resubmit.</div>
          </div>
          <div className="rounded-md bg-[#F7F8FA] px-3 py-2 text-xs text-[#6b7280]">
            <strong>Status guide:</strong> Draft = saved, not sent. Submitted = waiting for review. Approved = done! Returned = needs a fix.
          </div>
        </div>
        <DialogFooter>
          <Link to="/help" onClick={dismiss} className="text-xs font-semibold text-[#034AA2] hover:underline" data-testid="student-welcome-full-guide">Learn more in the Help Center</Link>
          <Btn onClick={dismiss} data-testid="student-welcome-dismiss">Got it!</Btn>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
